import trim from 'lodash/trim';

export const HOME_SEGMENT = 'home';

export function sanitizeAdvertisingSegment(segment = '') {
  const sanitized = trim(
    segment
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, '')
      .replace(/_{2,}/g, '_')
      .replace(/-{2,}/g, '-'),
    '-_',
  );

  return sanitized || HOME_SEGMENT;
}
